import { CrudViewFormItemType, CrudFormConfig, CrudFormTextBoxItem, InputSize } from '@rappider/rappider-components/utils';
import { Validators } from '@angular/forms';

export const ADD_SLOT_DEFINITION_CONFIG: CrudFormConfig = {
  items: [
    <CrudFormTextBoxItem>{
      title: 'SHARED.TITLE',
      fieldName: 'title',
      type: CrudViewFormItemType.TextBox,
      size: InputSize.Large,
      validators: [
        {
          type: Validators.required,
          errorKey: 'required',
          errorMessage: 'ERRORS.TITLE_REQUIRED'
        }
      ]
    },
    <CrudFormTextBoxItem>{
      title: 'SHARED.KEY',
      fieldName: 'key',
      type: CrudViewFormItemType.TextBox,
      validators: [
        {
          type: Validators.required,
          errorKey: 'required',
          errorMessage: 'ERRORS.TITLE_REQUIRED'
        }
      ],
      size: InputSize.Large
    },
    {
      title: 'SHARED.INDEX',
      fieldName: 'index',
      type: CrudViewFormItemType.Number,
      size: InputSize.Large
    },
    <CrudFormTextBoxItem>{
      title: 'SHARED.DESCRIPTION',
      fieldName: 'description',
      type: CrudViewFormItemType.TextArea,
      validators: [
        {
          type: Validators.required,
          errorKey: 'required',
          errorMessage: 'ERRORS.TITLE_REQUIRED'
        }
      ]
    }
  ],
  submitButton: {
    visible: false
  }
};
